<section class="contact">
  <div class="contact__inner row pad">
    <p class="contact__text">Shaping what’s next in live experiences</p>
    <a routerLink="/contact" class="btn contact__button">CONTACT US</a>
  </div>
</section>
